import { useActiveTooltipCoordinate, usePlotArea } from 'recharts'

import { ChartAnchoredTooltipBox } from './ChartAnchoredTooltipBox'

// The box mounts with the hover, so its mount effect sees the node it measures.
function ChartAnchoredTooltip({ children, isInsidePlot = false, top }) {
  const coordinate = useActiveTooltipCoordinate()
  const plotArea = usePlotArea()

  return coordinate ? (
    <ChartAnchoredTooltipBox
      isInsidePlot={isInsidePlot}
      plotArea={plotArea}
      top={top}
      x={coordinate.x}
    >
      {children}
    </ChartAnchoredTooltipBox>
  ) : null
}

export default ChartAnchoredTooltip
